module.exports = __webpack_public_path__ + "media/images/CHA-04-acb8daa6f717ca9199885924d74a5ca9.jpg";